import React, { useEffect, useState } from "react";
import { Field, reduxForm, change } from "redux-form";
import { connect } from "react-redux";
import FooterForm from "../../../Components/Lib/FooterForm";
import { renderAField, renderTextField } from "../../../Components/Forms/renders";
import switcbutton from "../../../Components/Forms/switch";
import renderDaterange from "../../../Components/Forms/daterange";
import { fetchervaringen } from "../../Ervaringen/Reducers/actions";
import SelectBox from "../../../Components/Forms/selectbox";
import { fetcharrangementen } from "../../Arrangementen/Reducers/actions";
import { SearchFeedFactoryLocations } from "../Reducers/items/actions";

const SyncValidationForm = ({ handleSubmit, initialValues, fetchervaringen, fetcharrangementen, dispatch }) => {
  const [ervaringen, setervaringen] = useState([]);
  const [arrangementen, setarrangementen] = useState([]);
  const [searchZipcode, setSearchZipcode] = useState("");
  const [searchHousenr, setSearchHousenr] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [searchStreet, setSearchStreet] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showLocationSearch, setShowLocationSearch] = useState(false);
  useEffect(() => {
    fetchervaringen().then((data) => {
      setervaringen(data.results);
      fetcharrangementen().then((data) => {
        setarrangementen(data.results);
      });
    });

    // Auto-populate search fields from current location data
    console.log("Initial values:", initialValues);
    if (initialValues && initialValues.location) {
      console.log("Location data:", initialValues.location);
      setSearchZipcode(initialValues.location.zipcode || "");
      setSearchHousenr(initialValues.location.housenr || "");
      setSearchCity(initialValues.location.city || "");
      setSearchStreet(initialValues.location.street || "");
    }
  }, [initialValues]);

  const searchFeedFactoryLocations = async () => {
    if (!searchZipcode && !searchCity) {
      alert("Vul minimaal een postcode of stad in");
      return;
    }

    setIsSearching(true);
    try {
      const searchParams = {
        zipcode: searchZipcode,
        housenr: searchHousenr,
        city: searchCity,
        street: searchStreet
      };

      const results = await dispatch(SearchFeedFactoryLocations(searchParams));
      setSearchResults(results);

      if (results.length === 0) {
        alert("Geen locaties gevonden. Pas de zoekgegevens aan en probeer opnieuw.");
      }
    } catch (error) {
      alert(error.message || "Er is een fout opgetreden bij het zoeken naar locaties");
    } finally {
      setIsSearching(false);
    }
  };

  const selectLocation = (location) => {
    console.log("Selected location:", location);

    // Extract address information from the selected location
    const address = location.contactinfo?.addresses?.[0];
    if (address) {
      // Update the form fields using redux-form's change action
      dispatch(change('eigenschappen_edit', 'location.label', location.label || location.name || ''));
      dispatch(change('eigenschappen_edit', 'location.street', address.street || ''));
      dispatch(change('eigenschappen_edit', 'location.housenr', address.housenr || ''));
      dispatch(change('eigenschappen_edit', 'location.zipcode', address.zipcode || ''));
      dispatch(change('eigenschappen_edit', 'location.city', address.city || ''));
      dispatch(change('eigenschappen_edit', 'location.country', address.country || 'Nederland'));

      // If coordinates are available
      if (address.gisCoordinates && address.gisCoordinates[0]) {
        dispatch(change('eigenschappen_edit', 'location.lat', address.gisCoordinates[0].ycoordinate));
        dispatch(change('eigenschappen_edit', 'location.lon', address.gisCoordinates[0].xcoordinate));
      }

      // Store FeedFactory reference
      dispatch(change('eigenschappen_edit', 'feedfactory.id', location.id));
      dispatch(change('eigenschappen_edit', 'feedfactory.trcid', location.trcid));
    }

    setShowLocationSearch(false);
    setSearchResults([]);
    alert(`Locatie geselecteerd: ${location.label || location.name}. De locatiegegevens zijn bijgewerkt.`);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="col-sm-12">
        <h4 className="info-text">Vul hier de eigenschappen in </h4>
      </div>

      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">FeedFactory Locatie Zoeken</h3>
          <div className="box-tools pull-right">
            <button
              type="button"
              className="btn btn-box-tool"
              onClick={() => setShowLocationSearch(!showLocationSearch)}
            >
              <i className={showLocationSearch ? "fa fa-minus" : "fa fa-plus"}></i>
            </button>
          </div>
        </div>
        {showLocationSearch && (
          <div className="box-body">
            <div className="row">
              <div className="col-md-3">
                <label>Postcode</label>
                <input
                  type="text"
                  className="form-control"
                  value={searchZipcode}
                  onChange={(e) => setSearchZipcode(e.target.value)}
                  placeholder="1234 AB"
                />
              </div>
              <div className="col-md-2">
                <label>Huisnummer</label>
                <input
                  type="text"
                  className="form-control"
                  value={searchHousenr}
                  onChange={(e) => setSearchHousenr(e.target.value)}
                  placeholder="123"
                />
              </div>
              <div className="col-md-3">
                <label>Stad</label>
                <input
                  type="text"
                  className="form-control"
                  value={searchCity}
                  onChange={(e) => setSearchCity(e.target.value)}
                  placeholder="Amsterdam"
                />
              </div>
              <div className="col-md-3">
                <label>Straat</label>
                <input
                  type="text"
                  className="form-control"
                  value={searchStreet}
                  onChange={(e) => setSearchStreet(e.target.value)}
                  placeholder="Hoofdstraat"
                />
              </div>
              <div className="col-md-1">
                <label>&nbsp;</label>
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={searchFeedFactoryLocations}
                  disabled={isSearching}
                >
                  {isSearching ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-search"></i>}
                </button>
              </div>
            </div>

            {searchResults.length > 0 && (
              <div className="row" style={{ marginTop: "20px" }}>
                <div className="col-md-12">
                  <h5>Gevonden locaties ({searchResults.length}):</h5>
                  <div className="table-responsive">
                    <table className="table table-striped table-hover">
                      <thead>
                        <tr>
                          <th>Naam</th>
                          <th>Adres</th>
                          <th>Stad</th>
                          <th>Status</th>
                          <th>Actie</th>
                        </tr>
                      </thead>
                      <tbody>
                        {searchResults.map((location, index) => (
                          <tr key={index}>
                            <td>{location.label || location.name || 'Onbekend'}</td>
                            <td>
                              {location.contactinfo?.addresses?.[0]?.street} {location.contactinfo?.addresses?.[0]?.housenr}
                            </td>
                            <td>{location.contactinfo?.addresses?.[0]?.city}</td>
                            <td>
                              <span className={`label ${location.wfstatus === 'approved' ? 'label-success' : 'label-warning'}`}>
                                {location.wfstatus}
                              </span>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-success"
                                onClick={() => selectLocation(location)}
                              >
                                Selecteer
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Vul hier de prijzen in </h3>
        </div>
        <div className="box-body">
          <Field name="priceinformation.extrapriceinformation.value" type="input" component={renderTextField} label="Vul hier de informatie in over de prijzen" />
        </div>
      </div>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Externe partners </h3>
        </div>
        <div className="box-body">
          <Field name="veluwedb.publiceren" type="input" component={switcbutton} label="Evenement publiceren naar Visit Veluwe" />
        </div>
      </div>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Toegankelijk </h3>
        </div>
        <div className="box-body">
          <Field name="location.toegankeijkheid.hondtoestaan" type="input" component={switcbutton} label="Zijn honden toegestaan?" />
          <Field name="location.toegankeijkheid.rolstoeltoegankelijk" type="input" component={switcbutton} label="Is de locatie rolstoeltoegankelijk?" />
          <Field name="location.toegankeijkheid.toegankelijkvoormindervaliden" type="input" component={switcbutton} label="Is de locatie toegankelijk voor mindervaliden?" />
        </div>
      </div>

      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Duurzaamheid </h3>
        </div>
        <div className="box-body">
          <Field name="location.duurzaamheid.greenkey" type="input" component={switcbutton} label="Heeft de locatie een greenkey?" />
        </div>
      </div>

      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Awards </h3>
        </div>
        <div className="box-body">
          <Field name="location.awards.michelin" type="input" component={switcbutton} label="Heeft de locatie een michelin award?" />
        </div>
      </div>

      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Markeer als top item</h3>
        </div>
        <div className="box-body">
          <Field name="top.active" type="input" component={switcbutton} label="Zet dit items als top item actief" />
          <Field name="top.datum" component={renderDaterange} mindate={true} maxdate={true} label="In welke periode wil je het item laten zien" />
        </div>
      </div>

      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Dit is een webshop item</h3>
        </div>
        <div className="box-body">
          <Field name="metadata.product" component={renderAField} label="Vul de url van de webshop in (webshop/379/klompenmakerspad)" />
        </div>
      </div>

      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Is dit item online boekbaar</h3>
        </div>
        <div className="box-body">
          <Field name="metadata.boekbaarheid.status" type="input" component={switcbutton} label="Is dit item online boekbaar?" />
          <Field name="metadata.boekbaarheid.id" inputvalue="_id" inputnaam="naam" options={ervaringen} type="input" component={SelectBox} label="Kies om het item aan een ervaring te koppelen" />
          <Field name="metadata.boekbaarheid.arrangement" inputvalue="_id" inputnaam="naam" options={arrangementen} type="input" component={SelectBox} label="Kies om het item aan een arrangement te koppelen" />
        </div>
      </div>

      <FooterForm />
    </form>
  );
};

const ReduxFormSensorEdit = reduxForm({
  form: "eigenschappen_edit", // a unique identifier for this form
})(SyncValidationForm);

const mapStateToProps = (state) => ({
  initialValues: state.items.item, // pull initial values from account reducer
});

export default connect(mapStateToProps, { fetchervaringen, fetcharrangementen, SearchFeedFactoryLocations })(ReduxFormSensorEdit);
